import { render } from "./signalr.vue?vue&type=template&id=4715a6ca"
import script from "./signalr.vue?vue&type=script&lang=js"
export * from "./signalr.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__